import { SET_DRAWER } from "./types";

export const setDrawer = payload => ({
    type: SET_DRAWER,
    payload
  });
  